import React, { useCallback } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { nvl } from 'utils/nvl';
import { useHistory } from "react-router-dom";
import Popup from 'popup/Popup';
import { customAxiosPostFunction } from 'utils/axiosFunction';

import { AreaEditablePopupContainer } from './AreaEditablePopup.css.js';

const AreaEditablePopup = ({ selectedArea, setSelectedArea, positionChanger, popupOpen, setPopupOpen }) => {
  const history = useHistory();
  const userId = useSelector(store => store.loginManager.status.currentUser);
  const confirmArea = async () => {
    const url = nvl(selectedArea.areaIdx, 0) === 0 ? '/api/area/insertData' : '/api/area/updateData';
    
    customAxiosPostFunction(history, url, {...selectedArea, 'rgstId': userId, 'rgstDt': new Date()})
      .then(response => {
        if (response !== null && response !== 0) {
          alert("등록완료");
          //dispatch(areaManager());
          setPopupOpen(false);
          setSelectedArea({});
        }
        else {
          alert("등록실패");
        }
      })
      .catch(function (error) {
        console.log(error);
      });
  }

  const editAreaData = useCallback((key, data) => {
    setSelectedArea(selectedArea => {
      return {
        ...selectedArea,
        [key]: data
      }
    });
  }, []);

  return(
    <Popup
      modal
      open={popupOpen}
      onClose={() => { setPopupOpen(false); }}
    >
      <AreaEditablePopupContainer>
        <div>
          <p>지역명</p>
          <input type="text" 
                 value={selectedArea.areaNm} 
                 onChange={({ target: { value }}) => { editAreaData('areaNm', value) }} /> 
        </div>
        <div>
        {nvl(selectedArea.areaIdx, 0) !== 0 &&
          <button onClick={() => positionChanger()}>
            위치수정
          </button>
        }
          <button onClick={() => confirmArea()}>
            {nvl(selectedArea.areaIdx, 0) === 0 ? '등록' : '수정'}
          </button>
        </div>
      </AreaEditablePopupContainer>
    </Popup>
  );
}

export default AreaEditablePopup;